import React from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import ZoomButtons from "components/map/ZoomButtons"
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api"
import { API_OPTIONS, DEFAULT_ZOOM, MAP_OPTIONS, MARKER_ICON } from "constants/map"

Location.propTypes = {
  height: PropTypes.number,
  centerLatLng: PropTypes.object,
  meetingLatLng: PropTypes.string
}

export default function Location({ height = 330, centerLatLng, meetingLatLng }) {
  const { isLoaded } = useJsApiLoader(API_OPTIONS)
  const zoom = DEFAULT_ZOOM
  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="rounded"
      mapContainerStyle={{ height }}
      options={{ ...MAP_OPTIONS, draggable: false }}
      center={centerLatLng}
      zoom={zoom}
    >
      {centerLatLng && meetingLatLng && (
        <Marker position={centerLatLng} icon={{ ...MARKER_ICON, scaledSize: new window.google.maps.Size(30, 30) }} />
      )}
      <div className="vstack position-absolute p-10 w-100 h-100 gap-10 pointer-events-none">
        <ZoomButtons />
      </div>
    </GoogleMap>
  ) : (
    <div className="hstack bg-white p-50 rounded" style={{ height: 330 }}>
      <Spinner className="m-auto" />
    </div>
  )
}
